import { Icons } from "assets";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ConfirmationModal from "shared/modal/confirmation";
import { resetAuthReducer } from "shared/redux/reducers/authSlice";
import { toastMessage } from "../toast";
import NavItem from "./navItem";
import styles from "./style.module.scss";

interface SideCanvasProps {
  setIsOpen: (val: boolean) => void;
  isOpen: boolean;
  sidebarArr: SideBarItemsType[];
}

const DashboardSideCanvas = ({
  isOpen,
  setIsOpen,
  sidebarArr,
}: SideCanvasProps) => {
  const { auth } = useSelector((state: any) => state.root);
  const dispatch = useDispatch();
  const location = useLocation();
  const [openConfirmationModal, setOpenConfirmationModal] =
    useState<boolean>(false);

  const handleOpenConfirmationModal = () => {
    setOpenConfirmationModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(false);
  };

  const handleLogout = () => {
    dispatch(resetAuthReducer());
    toastMessage("success", "Logged out successfully");
  };

  function handleClick(e: any) {
    const elem: any = document.getElementById("sideCanvas");
    if (!elem.contains(e.target)) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    let elem: any = document.getElementById("backDropContainer");
    elem.addEventListener("click", (event: any) => {
      handleClick(event);
    });

    // eslint-disable-next-line
  }, [location.pathname]);

  return (
    <div
      className={classNames(styles.backDropContainer, "md:hidden")}
      style={isOpen ? { visibility: "visible" } : { visibility: "hidden" }}
      id="backDropContainer"
    >
      <div
        className={classNames(
          styles.mainContainer,
          isOpen ? styles.shown : styles.hidden
        )}
        id="sideCanvas"
      >
        <div
          className={classNames(
            "flex justify-between items-center px-4 gap-4",
            styles.logoContainer
          )}
        >
          {/* <Icons.LogoABR /> */}
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              setIsOpen(false);
            }}
          >
            <Icons.Cross />
          </div>
        </div>
        <div
          className={classNames(
            "flex items-center gap-2",
            styles.userInfoContainer
          )}
        >
          <div className={classNames(styles.avtInitials)}>
            <label>
              {auth?.user?.fullname?.split(" ")?.[0]?.[0]}
              {auth?.user?.fullname?.split(" ")?.[1]?.[0]}
            </label>
          </div>
          <div className={classNames("flex flex-col items-start")}>
            <p>{auth?.user?.fullname}</p>
            <span>{auth?.user?.email}</span>
          </div>
        </div>
        <div className={classNames("flex flex-col justify-between gap-4 my-6")}>
          <div className="flex flex-col gap-4 ">
            {sidebarArr?.map((item, inx) => {
              return (
                <div className="flex flex-col items-start gap-3" key={inx}>
                  <label className={classNames(styles.navTitle)}>
                    {item?.title}
                  </label>

                  <div className="w-full">
                    {item?.paths?.map(
                      (s: SideBarItemPathType, s_inx: number) => {
                        const props = {
                          ...s,
                          setIsOpen,
                        };
                        return <NavItem {...props} key={s_inx} />;
                      }
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className={classNames(styles.navItemContainer)}
            onClick={handleOpenConfirmationModal}
          >
            <Icons.Logout className={classNames(styles.logoutIcon)} />
            <label
              className={classNames(
                styles.heading,
                styles.logout,
                "cursor-pointer"
              )}
            >
              Logout
            </label>
          </div>
        </div>
      </div>
      <ConfirmationModal
        show={openConfirmationModal}
        handleClose={handleCloseConfirmationModal}
        subtitle="Are you sure you want to logout?"
        actionButtonText="Yes, Logout"
        handleSubmit={handleLogout}
      />
    </div>
  );
};

export default DashboardSideCanvas;
